import React, { PropsWithChildren } from 'react';
import { Tag, TagType, TagVariant } from '@cmhc-schl/hearth-ui';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

interface LoanStatusPillProps {
  status: string;
  modified?: boolean;
  label: string;
  filled?: boolean;
}
const getLoanStatusName = (status: string) => {
  switch (status) {
    case '01':
      return 'received';
    case '02':
      return 'pass';
    case '03':
      return 'fail';
    case '04':
      return 'review';
    case '09':
      return 'deleted';
    default:
      return 'received';
  }
};

const getStatusIndicatorColor = (status: string) => {
  switch (status) {
    case 'new':
      return 'Violet';

    case 'review':
    case 'refused':
    case 'rejected':
    case 'unknown':
    case 'issued':
    case 'received':
      return 'Brown';

    case 'fail':
    case 'critical':
      return 'Red';

    case 'pass':
    case 'approved':
    case 'finalized':
      return 'Green';

    case 'risked':
    case 'offer':
      return 'Teal';

    case 'entered':
      return 'Grey';

    case 'priced':
    case 'lock':
    case 'saved':
    case 'rerisk':
      return 'Yellow';

    case 'expired':
    case 'withdrawn':
    case 'cancelled':
    case 'deleted':
    case 'delete':
      return 'DarkGrey';

    default:
      return 'Grey';
  }
};

const LoanStatusPill = ({
  status,
  modified,
  label,
  filled = true
}: PropsWithChildren<LoanStatusPillProps>) => {
  const { t } = useTranslation('HbtPortfolioManagementRequestOverview');
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        display: 'flex',
        whiteSpace: 'noWrap',
        overflow: 'hidden',
        textOverflow: 'ellipses'
      }}
      title={label}
    >
      <div className={styles.statusPillWrapper}>
        <Tag
          label={label}
          tagType={TagType.TAG}
          tagVariant={TagVariant.ICON_READONLY}
          statusIndicator={getStatusIndicatorColor(getLoanStatusName(status))}
          filled={filled}
        />
      </div>
      {modified && (
        <Typography className={styles.modifiedTag} sx={{ fontStyle: 'italic' }}>
          ({t('PI-Portfolio-Management-Loans-Detail-Modified')})
        </Typography>
      )}
    </Stack>
  );
};

export default LoanStatusPill;
